export const IconGrayAnalytics: {
  name: 'icon_gray_analytics-54c1eb582731'
} = {
  name: 'icon_gray_analytics-54c1eb582731'
}
